module.exports = __webpack_public_path__ + "static/media/How can I manually import emails.5c8e609d.png";